var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "page-boxed page-header-fixed page-sidebar-closed-hide-logo page-container-bg-solid"
    },
    [
      _c(
        "div",
        [
          _c("AdminHeader"),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-container" },
            [
              _c("Side"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-content-wrapper" },
                [
                  _c(
                    "div",
                    { staticClass: "page-content" },
                    [_c("router-view", { attrs: { name: "admin" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("AdminFooter")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "initial",
        staticStyle: { display: "none" },
        attrs: { id: "loader" }
      },
      [
        _c("div", { staticClass: "load-bg" }, [
          _c("div", { staticClass: "load" }, [
            _c("hr"),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "loadback" })
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-371030b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-371030b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminPanel.vue
// module id = null
// module chunks = 